import { GET_CURRENT_USER } from "./types";

const initialState = {
  currUser: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_USER:
      return {
        ...state,
        currUser: "Tarik",
      };
    default:
      return state;
  }
};
